type LogoProps = {
  size?: number;
};

export function Logo({ size = 22 }: LogoProps) {
  return (
    <img
      src="/logo-bird.png"
      width={size}
      height={size}
      alt="Noah's Farm"
      style={{ display: "block" }}
    />
  );
}
